<template>
  <div class="admin-work-detail-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('adminWorkDetail.title')" :subtitle="$t('adminWorkDetail.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 工单信息面板 -->
    <div class="ds-panel">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('adminWorkDetail.page.infoTitle') }}</span>
      </div>

      <div class="ds-info-grid">
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminWorkDetail.workId') }}</span>
          <span class="ds-info-grid__value ds-num">{{ adminWorkDetailInfo.workId || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminWorkDetail.workName') }}</span>
          <span class="ds-info-grid__value">{{ adminWorkDetailInfo.workName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminWorkDetail.typeName') }}</span>
          <span class="ds-info-grid__value">{{ adminWorkDetailInfo.typeName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminWorkDetail.workCycle') }}</span>
          <span class="ds-info-grid__value">
            {{ adminWorkDetailInfo.workCycle == '1001' ? $t('adminWorkDetail.once') : $t('adminWorkDetail.periodic') }}
          </span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminWorkDetail.startTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ adminWorkDetailInfo.startTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminWorkDetail.endTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ adminWorkDetailInfo.endTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminWorkDetail.createUserName') }}</span>
          <span class="ds-info-grid__value">{{ adminWorkDetailInfo.createUserName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminWorkDetail.curStaffName') }}</span>
          <span class="ds-info-grid__value">{{ adminWorkDetailInfo.curStaffName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminWorkDetail.curCopyName') }}</span>
          <span class="ds-info-grid__value">{{ adminWorkDetailInfo.curCopyName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminWorkDetail.stateName') }}</span>
          <span class="ds-info-grid__value">
            <ds-status-tag :label="adminWorkDetailInfo.stateName || '-'" :text="adminWorkDetailInfo.stateName"
              type="info" />
          </span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminWorkDetail.createTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ adminWorkDetailInfo.createTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminWorkDetail.attachment') }}</span>
          <span class="ds-info-grid__value">
            <el-link v-if="adminWorkDetailInfo.pathUrl" :href="adminWorkDetailInfo.pathUrl" target="_blank">
              {{ $t('common.download') }}
            </el-link>
            <span v-else>-</span>
          </span>
        </div>
      </div>
    </div>

    <!-- (3) Tab 面板 -->
    <div class="ds-panel ds-panel--tabs">
      <el-tabs v-model="adminWorkDetailInfo._currentTab" @tab-click="changeTab(adminWorkDetailInfo._currentTab)">
        <el-tab-pane :label="$t('adminWorkDetail.content')" name="adminWorkDetailContent"></el-tab-pane>
        <el-tab-pane :label="$t('adminWorkDetail.processor')" name="aWorkDetailTask"></el-tab-pane>
        <el-tab-pane :label="$t('adminWorkDetail.processContent')" name="aWorkDetailTaskItem"></el-tab-pane>
        <el-tab-pane :label="$t('adminWorkDetail.copyTo')" name="aWorkDetailCopy"></el-tab-pane>
        <el-tab-pane :label="$t('adminWorkDetail.workFlow')" name="aWorkDetailEvent"></el-tab-pane>
        <el-tab-pane :label="$t('adminWorkDetail.flowAttachment')" name="aWorkDetailFile"></el-tab-pane>
        <el-tab-pane :label="$t('adminWorkDetail.workType')" name="aWorkDetailType"></el-tab-pane>
        <el-tab-pane v-if="adminWorkDetailInfo.workCycle == '2002'" :label="$t('adminWorkDetail.workCycle')"
          name="aWorkDetailCycle"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- (4) Tab 内容面板 -->
    <div class="ds-panel ds-panel--body">
      <div v-if="adminWorkDetailInfo._currentTab === 'adminWorkDetailContent'">
        <div class="content-section" v-for="(item, index) in adminWorkDetailInfo.contents" :key="index">
          <div class="content-section__index">{{ item.seqNum }}、</div>
          <div v-html="item.content" class="content-section__text"></div>
        </div>
        <div v-if="!adminWorkDetailInfo.contents || adminWorkDetailInfo.contents.length === 0"
          class="ds-text-muted">
          {{ $t('adminWorkDetail.page.emptyContent') }}
        </div>
      </div>

      <a-work-detail-task v-else-if="adminWorkDetailInfo._currentTab === 'aWorkDetailTask'" ref="aWorkDetailTask"
        :work-id="adminWorkDetailInfo.workId"></a-work-detail-task>

      <a-work-detail-task-item v-else-if="adminWorkDetailInfo._currentTab === 'aWorkDetailTaskItem'"
        ref="aWorkDetailTaskItem" :work-id="adminWorkDetailInfo.workId"
        :contents="adminWorkDetailInfo.contents"></a-work-detail-task-item>

      <a-work-detail-copy v-else-if="adminWorkDetailInfo._currentTab === 'aWorkDetailCopy'" ref="aWorkDetailCopy"
        :work-id="adminWorkDetailInfo.workId"></a-work-detail-copy>

      <a-work-detail-event v-else-if="adminWorkDetailInfo._currentTab === 'aWorkDetailEvent'" ref="aWorkDetailEvent"
        :work-id="adminWorkDetailInfo.workId" :contents="adminWorkDetailInfo.contents"></a-work-detail-event>

      <a-work-detail-file v-else-if="adminWorkDetailInfo._currentTab === 'aWorkDetailFile'" ref="aWorkDetailFile"
        :work-id="adminWorkDetailInfo.workId" :contents="adminWorkDetailInfo.contents"></a-work-detail-file>

      <a-work-detail-type v-else-if="adminWorkDetailInfo._currentTab === 'aWorkDetailType'" ref="aWorkDetailType"
        :wt-id="adminWorkDetailInfo.wtId"></a-work-detail-type>

      <a-work-detail-cycle v-else-if="adminWorkDetailInfo._currentTab === 'aWorkDetailCycle'" ref="aWorkDetailCycle"
        :work-id="adminWorkDetailInfo.workId"></a-work-detail-cycle>
    </div>
  </div>
</template>

<script>
import { getWorkDetail } from '@/api/work/adminWorkDetailApi'
import AWorkDetailTask from '@/components/work/aWorkDetailTask'
import AWorkDetailTaskItem from '@/components/work/aWorkDetailTaskItem'
import AWorkDetailCopy from '@/components/work/aWorkDetailCopy'
import AWorkDetailEvent from '@/components/work/aWorkDetailEvent'
import AWorkDetailFile from '@/components/work/aWorkDetailFile'
import AWorkDetailType from '@/components/work/aWorkDetailType'
import AWorkDetailCycle from '@/components/work/aWorkDetailCycle'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'AdminWorkDetail',
  components: {
    AWorkDetailTask,
    AWorkDetailTaskItem,
    AWorkDetailCopy,
    AWorkDetailEvent,
    AWorkDetailFile,
    AWorkDetailType,
    AWorkDetailCycle,
    DsPageHeader,
    DsStatusTag
  },
  data() {
    return {
      adminWorkDetailInfo: {
        workId: '',
        wtId: '',
        workName: '',
        typeName: '',
        workCycle: '',
        startTime: '',
        endTime: '',
        createUserName: '',
        curStaffName: '',
        curCopyName: '',
        stateName: '',
        createTime: '',
        pathUrl: '',
        _currentTab: 'adminWorkDetailContent',
        contents: []
      }
    }
  },
  created() {
    this.adminWorkDetailInfo.workId = this.$route.query.workId
    if (this.$route.query.currentTab) {
      this.adminWorkDetailInfo._currentTab = this.$route.query.currentTab
    }
    this.loadWorkInfo()
  },
  methods: {
    async loadWorkInfo() {
      try {
        const params = {
          workId: this.adminWorkDetailInfo.workId,
          page: 1,
          row: 1
        }
        const { data } = await getWorkDetail(params)
        if (data && data.length > 0) {
          Object.assign(this.adminWorkDetailInfo, data[0])
        }
      } catch (error) {
        this.$message.error(this.$t('adminWorkDetail.fetchError'))
      }
    },
    changeTab(tab) {
      setTimeout(() => {
        if (this.$refs[tab]) {
          this.$refs[tab].loadData()
        }
      }, 500)
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-work-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-md);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

/* Tab 面板 */
.ds-panel--tabs {
  padding: 0 var(--ds-spacing-lg);
}

/* 明细内容面板 */
.ds-panel--body {
  padding: var(--ds-spacing-lg);
}

/* 信息栅格 */
.ds-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--ds-spacing-md) var(--ds-spacing-lg);
  padding: var(--ds-spacing-lg);

  &__item {
    display: flex;
    align-items: baseline;
    gap: var(--ds-spacing-sm);
    min-width: 0;
  }

  &__label {
    flex-shrink: 0;
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
  }

  &__value {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-900);
    word-break: break-all;
  }
}

/* 工单内容 */
.content-section {
  display: flex;
  gap: var(--ds-spacing-sm);
  padding: var(--ds-spacing-sm) 0;
  border-bottom: 1px solid var(--ds-gray-300);

  &:last-child {
    border-bottom: none;
  }

  &__index {
    flex-shrink: 0;
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-600);
  }

  &__text {
    flex: 1 1 auto;
    min-width: 0;
    text-align: left;
  }
}
</style>
